import React, { useState, useEffect } from "react";
import SpeakerNotesOutlinedIcon from "@mui/icons-material/SpeakerNotesOutlined";
import dateFormat, { masks } from "dateformat";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import swal from "sweetalert";
import axios from "axios";
import { MentionsInput, Mention } from "react-mentions";
import CommentRenderer from "./CommentRenderer";

import { api_path } from "../../shared";
const CustomerActivityTimeline = ({
  CRM_CUSCODE,
  SALES_ACTIVITY_ID,
  FROM,
  highlightActivityId,
}) => {
  const [getSalesList, setSalesList] = useState([]);
  const [getSelectedSales, setSelectedSales] = useState([]);
  const [getSales, setSales] = useState([]);
  const token = process.env.REACT_APP_API_TOKEN;
  const CRM_UID = JSON.parse(localStorage.getItem("USER_ID"));
  const [remark, setRemark] = useState("");
  const [mentions, setMentions] = useState([]);
  const [activitiesItem, setActivitiesItem] = useState([]);
  const queryParams = new URLSearchParams({
    CRM_CUSCODE: CRM_CUSCODE,
    CRM_UID: 0,
    SALES_ACTIVITY_ID: SALES_ACTIVITY_ID,
    EMP_CODE: "",
    ACTIVITY_DATE_FROM: "",
    ACTIVITY_DATE_TO: "",
  });
  const fetchActivitiesItem = async () => {
    const queryString = queryParams.toString();
    const url = `${api_path}/customer/customer_activities_item.php?${queryString}`;
    console.log("🔍 Full Fetch URL:", url);
    try {
      const response = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      // console.log("✅ Fetched activity item result:", result);
      // console.log("✅  activity item acts:", result); // <--- ดูตรงนี้
      if (result) {
        setActivitiesItem(result);
      } else {
        console.warn("⚠️ No activities found in response");
      }
      // console.log("🌟 Activities item raw:", result);
      // console.log("✅ Array check:", Array.isArray(result));
    } catch (error) {
      console.error("❌ Error fetching activities:", error);
    }
  };
  useEffect(() => {
    if (SALES_ACTIVITY_ID) {
      fetchActivitiesItem();
    }
  }, [SALES_ACTIVITY_ID]);

  const handleSubmit = (e) => {
    e.preventDefault();
    var data = {
      SALES_ACTIVITY_ID: SALES_ACTIVITY_ID,
      COMMENT: remark || "",
      MENTIONS: mentions || "",
      CRM_UID: CRM_UID || 0,
      UNREAD_STATUS: 0,
    };
    console.log("data...", data);
    fetch(`${api_path}/customer/customer_activities_item.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status == "200") {
          //swal("Done", "Save data successfully", "success").then(() => {
          if (FROM == "CUSTOMER") {
            fetchActivitiesItem(); // โหลดข้อมูลใหม่
            setRemark("");
            setMentions("");
            //window.location = `./customer?customer_id=${CRM_CUSCODE}`;
          } else if (FROM == "MODAL") {
          } else if (FROM == "ACTIVITY") {
            window.location.reload();

            setRemark("");
            setMentions("");
          }
          //});
        } else {
          swal("Sorry", result.message, "error");
        }
      });
  };
  const [users, setUsers] = useState([]);
  useEffect(() => {
    axios
      .get(`${api_path}/customer/sales-owner.php`, {
        params: {
          CUSTOMER_CODE: CRM_CUSCODE,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const mapped = res.data.map((u) => ({
          id: u.CRM_UID,
          display: u.UserNickName,
        }));
        // 👇 เพิ่ม user ที่ fix เองเข้าไป
        const fixedUsers = [
          { id: "71", display: "Rojanin (Peck)" },
          { id: "78", display: "Peerasit (Mod)" },
          { id: "79", display: "Kritpong (Kiang)" },
          { id: "160", display: "Chatchai (Tor)" },
          { id: "191", display: "Veerathep (Thep)" },
        ];
        //setUsers(mapped);
        // รวมสอง array เข้าด้วยกัน
        setUsers([...mapped, ...fixedUsers]);
      })
      .catch((err) => console.error(err));
  }, [CRM_CUSCODE]);

  const handleRemarkChange = (
    event,
    newValue,
    newPlainTextValue,
    newMentions
  ) => {
    setRemark(newValue);
    setMentions(newMentions.map((m) => m.id));
  };

  useEffect(() => {
    // if (comments.length === 0) return; // ยังไม่มี comment โหลด
    const hash = window.location.hash;
    if (!hash) return;

    // ใช้ requestAnimationFrame หรือ setTimeout เล็กน้อยให้ DOM render
    const scrollToHash = () => {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    // รอ 2 frames เพื่อให้ React render DOM
    requestAnimationFrame(() => {
      requestAnimationFrame(scrollToHash);
    });
  }, [SALES_ACTIVITY_ID]); // รันใหม่ทุกครั้งที่ comments เปลี่ยน
  const [showComment, setShowComment] = useState(false);
  const [showCommentBox, setShowCommentBox] = useState(false);
  useEffect(() => {
    if (showComment && activitiesItem.length > 0) {
      // เลือกกิจกรรมล่าสุดเป็นเจ้าของกิจกรรม
      const lastActivity = activitiesItem[activitiesItem.length - 1];
      const mentionString = `@[${lastActivity.USER_NICKNAME}](${lastActivity.CREATE_BY}) `;
      setRemark(mentionString);
      setMentions([lastActivity.CREATE_BY]);
    }
  }, [showComment, activitiesItem]);
  // ✅ เปิด comment + scroll ไปยัง comment ที่เลือก
  useEffect(() => {
    if (
      highlightActivityId &&
      activitiesItem.some(
        (x) => String(x.SALES_ACTIVITY_ITEM_ID) === String(highlightActivityId)
      )
    ) {
      setShowComment(true);

      // ✅ หน่วงให้ render comment เสร็จก่อน
      const timer = setTimeout(() => {
        const commentEl = document.getElementById(
          `comment-${highlightActivityId}`
        );
        if (commentEl) {
          commentEl.scrollIntoView({ behavior: "smooth", block: "center" });
          commentEl.style.transition = "background-color 0.5s ease";
          commentEl.style.backgroundColor = "#EBEBEB";
          setTimeout(() => {
            commentEl.style.backgroundColor = "transparent";
          }, 2000);
        }
      }, 800);

      return () => clearTimeout(timer);
    }
  }, [highlightActivityId, activitiesItem]);
  return (
    <div className="">
      <hr />
      <div className="">
        {!showComment && (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setShowComment(true);
              // ✅ ถ้ามี activity แล้ว ให้ mention คนล่าสุดทันที
              // if (activitiesItem.length > 0) {
              //   const lastActivity = activitiesItem[activitiesItem.length - 1];
              //   const mentionString = `@[${lastActivity.USER_NICKNAME}](${lastActivity.CREATE_BY}) `;
              //   setRemark(mentionString);
              //   setMentions([lastActivity.CREATE_BY]);
              // }
            }}
            className="link"
          >
            Comment ({activitiesItem.length})
          </a>
        )}

        {showComment && (
          <div className="timeline-item-v2-component">
            {activitiesItem.map((item, index) => (
              <div
                key={item.SALES_ACTIVITY_ITEM_ID}
                id={`comment-${item.SALES_ACTIVITY_ITEM_ID}`}
              >
                {/* <div key={index} className="timeline-item-v2-component-box"> */}

                <div className="timeline-item-content-wrapper-comment">
                  <p className="labelnormal">
                    {item.USER_NICKNAME}&nbsp;{" "}
                    {dateFormat(item.CREATE_DATE, "dd/mm/yy HH:MM")}
                  </p>
                  {item.COMMENT && (
                    <p className="font8">
                      <CommentRenderer comment={item.COMMENT} />
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {showComment && (
        <form onSubmit={handleSubmit} id="commentForm">
          <Grid item xs={12} sm={12}>
            <div
              style={{
                position: "relative",
                width: "90%",
                border: "1px solid #ccc",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <MentionsInput
                value={remark}
                // onChange={handleRemarkChange}
                onChange={(event, newValue, newPlainTextValue, newMentions) => {
                  // จำกัดความยาวของข้อความ (ไม่เกิน 1000 ตัว)
                  if (newPlainTextValue.length <= 1000) {
                    setRemark(newValue);
                    setMentions(newMentions.map((m) => m.id));
                  }
                }}
                style={{
                  control: {
                    backgroundColor: "#fff",
                    fontSize: 16,
                    minHeight: 120, // fix row 6 (ประมาณ 20px * 6)
                    maxHeight: 120, // fix สูงคงที่
                    padding: 8,
                    overflow: "auto", // scroll ถ้าพิมพ์เกิน
                    lineHeight: "20px",
                    whiteSpace: "pre-wrap", // ✅ ให้รองรับบรรทัดใหม่
                    wordWrap: "break-word", // ✅ ตัดคำยาว
                  },
                  highlighter: {
                    overflow: "hidden",
                    whiteSpace: "pre-wrap", // ✅ ให้ highlighter แสดงบรรทัดใหม่ด้วย
                    wordWrap: "break-word",
                  },
                  input: {
                    margin: 0,
                    padding: "10px",
                    minHeight: "120px", // ให้ input เต็มความสูง
                    lineHeight: "20px",
                    verticalAlign: "top", // ข้อความชิดบน
                    borderRadius: "8px", // Apply border-radius here
                    color: "#000000ff",
                    whiteSpace: "pre-wrap", // ✅ แสดงบรรทัดใหม่จริงเวลา render ค่า
                    wordWrap: "break-word",
                  },
                }}
                placeholder="Type @ to mention someone..."
              >
                <Mention
                  trigger="@"
                  data={users}
                  style={{
                    backgroundColor: "#daf4fa",
                  }}
                />
              </MentionsInput>
              {/* ✅ ปุ่ม submit อยู่ข้างในกล่อง */}
              <button
                type="submit"
                style={{
                  position: "absolute",
                  right: 10,
                  bottom: 10,
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "6px 12px",
                  cursor: "pointer",
                  fontSize: 13,
                  transition: "background 0.3s",
                }}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = "#125a9c")
                }
                onMouseOut={(e) => (e.target.style.backgroundColor = "#1976d2")}
              >
                Send
              </button>
            </div>
            {/* ตัวอักษรที่พิมพ์และปุ่มเคลียร์ */}
            <div
              style={{
                display: "inline",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 4,
                fontSize: 12,
                color: "#555",
                width: 400,
              }}
            >
              <span>{remark.length} / 1000 characters</span>&nbsp;&nbsp;&nbsp;
              {/* <Button
                size="small"
                variant="outlined"
                onClick={() => {
                  setRemark("");
                  setMentions([]);
                }}
              >
                Clear
              </Button> */}
            </div>
          </Grid>
        </form>
      )}
    </div>
  );
};

export default CustomerActivityTimeline;
